import * as React from 'react';
import { cn } from '@/lib/utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Base
          'flex h-10 w-full rounded-lg border border-input bg-background px-3 py-2 text-sm',
          // Placeholder mais sutil
          'placeholder:text-muted-foreground/60',
          // Arquivo
          'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground',
          // Transição suave — borda fica primary no focus
          'ring-offset-background transition-all duration-150',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
          // Desabilitado
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
